import React from 'react'
import EnergyFields from './EnergyFields'
import { EnergyConsumption } from '~/api/services/co2'

interface Props {
  energyConsumptions: EnergyConsumption[]
}

const NineStep: React.FC<Props> = ({ energyConsumptions }) => {

  return <>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <EnergyFields
        energyConsumptions={energyConsumptions}
      />
    </div>
  </>
}
export default NineStep